import React from "react"
import {H4} from "@irati/ui/src/Typography"
import {Hr, Row, Col} from "@irati/ui/src/Layout"
import {Deal} from "@irati/types"
import {BasketTotals} from "@irati/checkout/utils/basket/helper/calculateTotals"
import styled, {createGlobalStyle} from "styled-components"
import {UseBasket} from "@irati/checkout/utils/basket/useBasket"
import {SelectedEmail, ProductList} from "../CommonElements"
import Total from "../Total"
import {PointsBreakdown} from "./PointsBreakdown"
import {usePointsBlendQuery} from "@irati/wallet/hooks/pointsBlend"

export const SubTotal = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  /* resise currency icons */
  & img {
    width: 16px;
  }
`

interface Props {
  deal: Deal
  email?: string
  walletBalanceToUse?: number
  totals: BasketTotals
  basket: UseBasket
  products: any
}

export const FlexStyles = createGlobalStyle`
    /* First we have a base flex class to apply to any input that we want to flexify and fill it's container */
    /* the idea is to then let the parent define width */
    .flex-override {
        display: flex;
        flex: 1;
        width: 100%;
        padding: unset;
        margin: unset;
    }
`
const OrderSummaryTT: React.FC<Props> = ({deal, email, walletBalanceToUse, totals, basket, products}) => {
  const {data: pointsBlend} = usePointsBlendQuery()
  return (
    <div>
      <Row>
        <Col md={12}>
          <H4 marginTop={3} overflowWrap="break-word">
            {deal.header}
          </H4>
          <Hr />
          {email && deal.emailRequired && <SelectedEmail email={email} />}
          {totals && totals.hasSelectedAProduct && <ProductList data={products} breakdown={basket.breakdown} />}
          {basket.pointBreakdown && pointsBlend?.walletBlend.visible && <PointsBreakdown pointBreakdown={basket.pointBreakdown} />}
          {((!!totals.subtotal && totals.subtotal > 0) || (!!walletBalanceToUse && walletBalanceToUse > 0)) && (
            <div>
              <Total total={totals.subtotal} currency={basket.breakdown.total?.currency} />
            </div>
          )}
        </Col>
      </Row>
    </div>
  )
}

OrderSummaryTT.defaultProps = {
  email: "",
  walletBalanceToUse: 0,
  totals: {}
}

export default OrderSummaryTT
